/* eslint-disable */

import { useEffect, useState } from "react";
import { HiX } from "react-icons/hi";
import { useLocation, useNavigate } from "react-router-dom";
import { useGlobalContext } from "context/globalContext";
import SidebarCard from "components/sidebar/componentsrtl/SidebarCard";
import routes, { getFilteredRoutes } from "../../routes";
import ZenvoyaLogo from "assets/svg/ZenvoyaLogo";
import ZenvoyaNewLogo from "assets/svg/ZenvoyaNewLogo.svg";

const Sidebar = ({ open, onClose }) => {
  const { userDetails } = useGlobalContext();
  const [filteredRoutes, setFilteredRoutes] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  const getUserRole = () => {
    if (userDetails?.role) return userDetails.role;

    try {
      const storedUser = localStorage.getItem("userDetails");
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        return parsedUser?.role;
      }
    } catch (err) {
      console.error("Error:", err);
    }

    return null;
  };

  const userRole = getUserRole();

  useEffect(() => {
    const accessibleRoutes = getFilteredRoutes(userRole);
    setFilteredRoutes(accessibleRoutes);
  }, [userDetails, userRole]);

  const isRouteActive = (route) => {
    const currentPath = location.pathname;
    const routeFullPath = `${route.layout}${
      route.layout.endsWith("/") ? "" : "/"
    }${route.path}`;

    if (currentPath === routeFullPath) return true;
    if (currentPath.startsWith(routeFullPath + "/")) return true;
    return false;
  };

  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-900 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[0px] mt-[60px] flex items-center justify-center`}>
        <div className="mt-1 ml-1 h-auto w-40">
          <img src={ZenvoyaNewLogo} alt="new logo" />
        </div>
      </div>
      <div className="mt-[58px] mb-7 h-px bg-gray-300 dark:bg-white/30" />

      <ul className="mb-auto -ml-2 max-h-[calc(100vh-200px)] overflow-y-auto pt-1">
        {filteredRoutes.length > 0 ? (
          filteredRoutes.map((route, index) => {
            const fullPath = `${route.layout}${
              route.layout.endsWith("/") ? "" : "/"
            }${route.path}`;
            const isActive = isRouteActive(route);

            return (
              <li key={index} className="mb-1">
                <button
                  className={`flex w-full items-center gap-3 rounded-lg p-3 text-left transition-all duration-200 ${
                    isActive
                      ? "bg-brand-50 text-brand-500 shadow-md shadow-brand-500/20 dark:bg-brand-400/20 dark:text-white"
                      : "text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/5"
                  }`}
                  onClick={() => {
                    console.log(`Navigating to: ${fullPath}`);
                    navigate(fullPath);
                  }}
                >
                  <div
                    className={`text-xl ${
                      isActive
                        ? "text-brand-500 dark:text-white"
                        : "text-gray-500 dark:text-gray-400"
                    }`}
                  >
                    {route.icon || ""}
                  </div>
                  <div className="flex-1">
                    <p
                      className={`font-medium ${
                        isActive ? "text-brand-500 dark:text-white" : ""
                      }`}
                    >
                      {route.name}
                    </p>
                  </div>
                  {isActive && (
                    <div className="h-2 w-2 rounded-full bg-brand-500"></div>
                  )}
                </button>
              </li>
            );
          })
        ) : (
          <div className="p-4">
            <p className="font-bold text-red-500">NO ROUTES FOUND!</p>
            <p className="text-sm"> user role id {userRole}</p>
          </div>
        )}
      </ul>

      <div className="flex justify-center">
        <SidebarCard />
      </div>
    </div>
  );
};

export default Sidebar;
